let language = {
    "ESHOPER-BUSINESS-FORM-TITLE": "合作伙伴信息",
    "ESHOPER-BUSINESS-FORM-NAME": "公司名称",
    "ESHOPER-BUSINESS-TIPS-APPEAR": "此信息将显示在您的发票上",
    "ESHOPER-BUSINESS-FORM-TIPS-NAME": "必须填写公司名称",
    "ESHOPER-BUSINESS-FORM-CONTACT": "联系方式",
    "ESHOPER-BUSINESS-FORM-FULL-NAME": "昵称",
    "ESHOPER-BUSINESS-FORM-FULL-NAME-TIPS": "联系人为必填项",
    "ESHOPER-BUSINESS-FORM-COUNTRY-CODE": "国家代码",
    "ESHOPER-BUSINESS-FORM-COUNTRY-CODE-TIPS": "国家代码为必填",
    "ESHOPER-BUSINESS-FORM-COUNTRY-CODE-TIPS-INVALID": "国家代码无效",
    "ESHOPER-BUSINESS-FORM-PHONE": "电话",
    "ESHOPER-BUSINESS-FORM-PHONE-TIPS": "电话为必填项",
    "ESHOPER-BUSINESS-FORM-PHONE-TIPS-INVALID": "电话无效",
    "ESHOPER-BUSINESS-FORM-EMAIL": "电子邮箱",
    "ESHOPER-BUSINESS-FORM-EMAIL-TIPS": "电子邮箱为必填项",
    "ESHOPER-BUSINESS-FORM-EMAIL-TIPS-INVALID": "电子邮箱无效",
    "ESHOPER-BUSINESS-FORM-ADDRESS": "地址",
    "ESHOPER-BUSINESS-FORM-REGION": " 国家/地区",
    "ESHOPER-BUSINESS-FORM-REGION-TIPS": "国家/地区为必填项",
    "ESHOPER-BUSINESS-FORM-RESULT-EMPTY": "没有匹配结果",
    "ESHOPER-BUSINESS-FORM-STATE": "州/省",
    "ESHOPER-BUSINESS-FORM-STATE-TIPS": "州/省为必填项",
    "ESHOPER-BUSINESS-FORM-CITY": "城市/城镇",
    "ESHOPER-BUSINESS-FORM-CITY-TIPS": "城市/城镇为必填项",
    "ESHOPER-BUSINESS-FORM-POSTAL-CODE": " 邮政编码",
    "ESHOPER-BUSINESS-FORM-POSTAL-CODE-TIPS": " 邮政编码为必填项",
    "ESHOPER-BUSINESS-FORM-POSTAL-CODE-TIPS-INVALID": "邮政编码无效",
    "ESHOPER-BUSINESS-FORM-ADDRESS1": "地址 1",
    "ESHOPER-BUSINESS-FORM-ADDRESS1-TIPS": "地址为必填项",
    "ESHOPER-BUSINESS-FORM-ADDRESS2": "地址 2",
    "ESHOPER-BUSINESS-FORM-SAVE-BUTTON": "保存",
    "ESHOPER-BUSINESS-FORM-ESHOP": "网上商店",
    "ESHOPER-BUSINESS-FORM-ESHOP-RETURN-ADDRESS": "退货地址",
    "ESHOPER-BUSINESS-FORM-ESHOP-SELECT-ADDRESS": "选择地址",
    "ESHOPER-BUSINESS-FORM-ESHOP-RETURN-ADDRESS-TIPS": "此地址供您的客户将产品退回给您",
    "ESHOPER-BUSINESS-FORM-ESHOP-RETURN-ADDRESS-EMPTY": "无退货地址",
    "ESHOPER-BUSINESS-FORM-ESHOP-PLACEHOLDER-COUNTRY": "搜索国家",
    "ESHOPER-BUSINESS-FORM-ESHOP-PLACEHOLDER-STATE": "搜索州 / 省",
    "ESHOPER-BUSINESS-FORM-ESHOP-PLACEHOLDER-CITY": "城市",
    "ESHOPER-BUSINESS-FORM-ESHOP-PLACEHOLDER-POSTAL-CODE": "邮政编码",
};

export { language }